// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__15iA2","buttons":"Footer_buttons__13BaH"};